import dayjs from 'dayjs';
import {
  DayPopulation, FloatingPopulation, GenderAgePopulation, PopulationCompare
} from '@/map/@types';
import {withComma} from '@/utils';
import {HOUSE_POPULATION_CHART_INFO} from './constants';

export const chartWithComma = (n: number) => String(withComma(n));

export const yearMonthTickFormatter = (value: any) => {
  if (value) {
    return dayjs(value + '01').format('YYYY.MM');
  }

  return value;
};

export const getHouseholdCompareData = (items?: PopulationCompare[]) => {
  if (!items || items.some((i) => !i?.house)) {
    return;
  }

  return items.map((i, idx) => {
    const total = Object.values(i.house).reduce((acc, cur) => acc + cur, 0);
    const percentage = Object.entries(i.house).map(([key, value]) => ({
      key,
      percent: value / total,
      count: value,
    }));
    percentage.sort(
      (a, b) =>
        HOUSE_POPULATION_CHART_INFO[a.key].order -
        HOUSE_POPULATION_CHART_INFO[b.key].order
    );

    return {
      ...i,
      idx,
      total,
      percentage: percentage.filter((i) => i.percent > 0),
    };
  });
};

export const addGenderAgeTotalValue = (
  items?: GenderAgePopulation[],
  agesLength?: number
) => {
  if (!items) {
    return;
  }

  const result = items.map((population) => {
    if (!population) {
      return population;
    }

    return Object.entries(population).reduce((acc, [key, value]) => {
      if (value.length === agesLength) {
        return acc;
      }

      (acc as any)[key as string] = [
        value.reduce((acc: any, cur: number) => acc + Math.floor(cur), 0),
        ...(acc as any)[key],
      ].map((i) => Math.floor(i));

      return acc;
    }, population);
  });

  return result;
};

export const processFootTrafficData = (items?: FloatingPopulation[]) => {
  if (!items || items.some((i) => !i)) {
    return;
  }

  return items.map((item) => {
    const day = item.day?.filter(
      (d) => d.hour && d.hour > 1
    ) as DayPopulation[];
    const week = item.week?.filter(
      (d) => d.hour && d.hour > 1
    ) as DayPopulation[];

    const populationTotal = day.map((d, idx) => ({
      hour: d.hour,
      totalPopulation: d.totalPopulation
        ? d.totalPopulation + (week[idx]?.totalPopulation || 0)
        : 0,
    })) as DayPopulation[];

    return {
      day,
      week,
      populationTotal,
    };
  });
};
